<template>
  <AppRow>
    <AppColumn
      v-if="def.folderSubject && def.folderSubject.name"
      class="px-0 overflow-y-auto"
      style="height: 74vh"
      :cols="
        (def.folderSubject && def.folderSubject.hasSearchPage) ||
          def.folderSubject.hasSearchPage === undefined
          ? 4
          : 12
      "
    >
      <FolderTree
        :def="{ searchPage: def, ...def.folderSubject }"
        :model="model"
        @active="folderActivated"
      />
    </AppColumn>
    <AppColumn
      v-if="
        def.folderSubject
          ? def.folderSubject.hasSearchPage ||
            def.folderSubject.hasSearchPage === undefined
          : true
      "
      :cols="def.folderSubject && 8"
    >
      <AppRow
        align="center"
        style="padding: 17px 20px 5px"
      >
        <AppColumn
          transition="scale-transition"
          class="d-flex align-center"
        >
          جستجوی {{ $t(def) }}
          <AbrBasicSearch
            style="max-width: 456px"
            class="mr-4"
            :def="{
              searchConfig: { searchPage: def, ...def.searchConfig },
              ...def.searchConfig.basicSearch,
            }"
            :model.sync="model"
            :folder-search="folderActivated"            
          ></AbrBasicSearch>
        </AppColumn>
        <!--          <AppColumn v-if="def.searchConfig.basicSearch.properties" class="text-end d-flex justify-end">-->
        <!--            <AbrSearchProp-->
        <!--              v-for="prop in def.searchConfig.basicSearch.properties"-->
        <!--              :key="prop.id"-->
        <!--              :def="prop"-->
        <!--              :model="model.basicSearch.query"-->
        <!--            />-->
        <!--          </AppColumn>-->
        <AppColumn class="text-end d-flex justify-end">
          <AppPortalTarget :name="`${def.searchConfig.advancedSearch.searchResult.id}.gridactions`"></AppPortalTarget>
          <AbrBtn v-for="action in def.actions &&
            def.actions.filter((act) => !act.actionLocation)" :key="action.id" :def="{ searchPage: def, ...action }"
            :model="model" class="mx-1" @onActionComplete="setEmptyAbrGrideSelectedItems">
            {{ $t(action) }}
          </AbrBtn>
          <AbrSearchProp v-for="prop in def.searchConfig.basicSearch.properties" :key="prop.id"
            style="margin-left: 40px !important" :def="prop" :model="model.basicSearch.query" hide-details cols="4"
            rounded dense />
        </AppColumn>
        <AppDialog v-if="!def.folderSubject && model.openAS" v-model="model.openAS" width="60vw">
          <AbrAdvancedSearch :def="{
            searchConfig: { searchPage: def, ...def.searchConfig },
            ...def.searchConfig.advancedSearch,
          }" :model.sync="model"></AbrAdvancedSearch>
        </AppDialog>
        <!-- <transition  name="slide">
            <AppRow  justify="space-between" class="pa-0" style="position: fixed; z-index: 99;margin: 0!important;margin-left: 28px;" :style="{'top': (this.def.form.pages.length === 1) ? '117px' : '166px'}" v-if="!def.folderSubject && model.openAS">
                <div style="width:100vw; height:100vh; position:fixed; top:0; right:0; z-index:-1;" @click='closeAS'></div>
              <AppColumn class="pa-0 mx-0" cols="9">
                <AbrAdvancedSearch
                    :def="{
                  searchConfig: { searchPage: def, ...def.searchConfig },
                  ...def.searchConfig.advancedSearch,
              }"
                    :model.sync="model"
                ></AbrAdvancedSearch>
              </AppColumn>
            </AppRow>
          </transition> -->
      </AppRow>
      <AppRow class="BG2" style="height: 15px"> </AppRow>
      <!-- <portal :to="tabIndex()"> -->
      <AppRow v-if="model.showGrid" justify="center"
        :style="{ 'max-height': def.form.pages.length > 1 ? '72.5vh' : '79vh' }">        
        <AppColumn cols="12" class="pa-0">
          <AbrGrid v-model="resultModel.results" :selected.sync="model.abrGrideSelectedItems"
            @selectedItems="setAbrGrideSelectedItems" style="padding: 0 13px" class="search-in-stepper"
            :def="def.searchConfig.advancedSearch.searchResult" :model="model.result" :loading="model.loading"
            :has-tabs="def.form.pages.length > 1 ? '64.5vh' : '71.2vh'"></AbrGrid>
        </AppColumn>
      </AppRow>
      <!-- </portal> -->
    </AppColumn>
  </AppRow>
</template>

<script>
import AbrBasicSearch from "@/components/search/AbrBasicSearch";
import AbrBtn from "@/components/library/action/AppButton";
import AppRow from "@/components/library/container/AppRow";
import AppColumn from "@/components/library/container/AppColumn";
import AbrAdvancedSearch from "@/components/search/AbrAdvancedSearch";
import AbrGrid from "@/components/library/grids/AbrGrid";
import FolderTree from "@/components/search/FolderTree";
import AppDialog from "@/components/library/container/AppDialog";
import { advancedSearch } from "@/apis";
import AbrSearchProp from "./AbrSearchProp";
import AppPortalTarget from "@/components/library/portal/AppPortalTarget";

export default {
  name: "AbrSearchForm",
  components: {
    AbrSearchProp,
    AbrGrid,
    AbrAdvancedSearch,
    AppColumn,
    AppRow,
    AbrBtn,
    AbrBasicSearch,
    FolderTree,
    AppDialog,
    AppPortalTarget,
  },
  props: ["def", "Model"],
  data: function () {
    return {
      resultModel: this.Model,      
      model: {
        abrGrideSelectedItems: [],
        basicSearch: {
          query: {},
        },
        advancedSearch: {
          query: null,
          orderBy: [{ id: Symbol() }],
        },
        showGrid: false,
        loading: false,
        openAS: false,
        result: [],
        folderId: null,
      },
    };
  },

  created() {    
    if (this.def.searchConfig.filterValue) {
      let res = this.$eval(this.def.searchConfig.filterValue);
      this.$set(
        this.model.basicSearch.query,
        this.def.searchConfig.basicSearch.fn.args[1].name,
        res
      );
    }
    if (this.def.folderSubject) this.model.showGrid = true;
    this.def.searchConfig.advancedSearch.searchResult.properties =
      this.def.searchConfig.advancedSearch.searchParam.properties.filter(
        (p) => p.isResultProp || p.isResultProp === undefined
      );
    // if (this.$route.meta && this.$route.meta[this.def.name] && this.$route.meta[this.def.name].model) {
    //   const model = this.$route.meta[this.def.name].model
    //   this.$set(this, "model", model)
    // } else {
    this.$route.meta[this.def.name] = { model: this.model };
    // }

    this.$watch(
      `model.result`,
      async (newModel) => {
        this.setEmptyAbrGrideSelectedItems();        
      }
    );
  },
  methods: {
    setAbrGrideSelectedItems(items) {      
      this.$set(this.model, "abrGrideSelectedItems", items);
    },
    setEmptyAbrGrideSelectedItems() {      
      this.$set(this.model, "abrGrideSelectedItems", []);
    },
    tabIndex() {
      return this.$store.state.tabManagement.tabs
        .findIndex((t) => t.form.id === this.def.form.id)
        .toString();
    },
    closeAS() {
      this.model.openAS = false;
    },
    async folderActivated(a) {
      this.model.folderId = (a && a.length && a[0]) || null;
      if (
        this.def.folderSubject.hasSearchPage ||
        this.def.folderSubject.hasSearchPage === undefined
      ) {
        if (!this.model.folderId) return;

        this.model.loading = true;
        const nodeParam =
          this.def.searchConfig.advancedSearch.searchParam.properties.find(
            (prop) => prop.isParamProp === undefined || prop.isParamProp
          );
        try {
          this.model.result = await advancedSearch(this.def.searchConfig.id, {
            query: {
              [nodeParam.name]: {
                condition: "EQ",
                value: this.model.folderId,
              },
            },
          });
        } finally {
          this.model.loading = false;
        }
      }
    },
  },
};
</script>
<style>
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 400px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.search-page-title {
  background-color: red;
}
</style>
